import { ChangeDetectionStrategy, Component, booleanAttribute, input } from '@angular/core';
import { ZagIcon } from '../icon/icon';

/** Centred "nothing here" state; sibling of `zag-loading-state` and `zag-error-state`. Actions are projected via `slot="actions"`. */
@Component({
  selector: 'zag-empty-state',
  imports: [ZagIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'zag-empty-state',
    '[class.zag-empty-state--compact]': 'compact()',
  },
  template: `
    @if (icon(); as name) {
      <span class="zag-empty-state__icon" [zagIcon]="name" aria-hidden="true"></span>
    }
    <p class="zag-empty-state__message">{{ message() }}</p>
    @if (description(); as text) {
      <p class="zag-empty-state__description">{{ text }}</p>
    }
    <div class="zag-empty-state__actions"><ng-content select="[slot=actions]" /></div>
  `,
  styleUrl: './empty-state.component.scss',
})
export class EmptyStateComponent {
  readonly message = input.required<string>();
  readonly description = input<string | null>(null);
  readonly icon = input<string | null>(null);
  readonly compact = input(false, { transform: booleanAttribute });
}
